<template>
  <div id="addressMap">
    <div id="container" class="contain"></div>
    <div class="address_ul">
      <div class="addres_li">
        <span>我的位置 : </span>
        <div class="address-moment">{{ address }}</div>
      </div>
      <van-form validate-first @submit="clock()">
        <div class="addres_li">
          <span class="limit">图片：</span>
          <van-uploader
            v-model="fileList"
            :max-count="1"
            capture
            :after-read="afterRead"
            :rules="[{ required: true, message: '请选择照片' }]"
          />
        </div>
        <div class="addres_li">
          <span class="limit" style="width: 80px;">备注：</span>
          <van-field
            v-model="remark"
            type="textarea"
            maxlength="300"
            placeholder="请输入"
            show-word-limit
          />
        </div>
        <div class="address_footer">
          <van-button
            type="info"
            size="normal"
            class="field-clock-btn"
            native-type="submit"
            >提交</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { getLocalStorage } from '@utils'
import { uploadImg, addRemark } from '@api/lishui'
export default {
  // props: ['addressList'],
  props: {
    addressList: {
      type: Object
    }
  },
  components: {},
  data() {
    return {
      fileList: [],
      remark: '',
      fileListUrl: '',
      address: '',
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  computed: {},
  watch: {},

  created() {},
  mounted() {
    this.map = new AMap.Map('container', {
      resizeEnable: true
    })
    this.map.setZoom(16)
    this.address = this.addressList.formattedAddress.split('省')[1]
    if (this.addressList) {
      let point = this.addressList.position

      this.map.setCenter([point.lng, point.lat])
      var marker = new AMap.Marker({
        position: new AMap.LngLat(point.lng, point.lat) // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      })
      this.map.add(marker)
    }
  },
  methods: {
    /**
     * @description 上传图片
     */
    afterRead(file) {
      file.status = 'uploading'
      file.message = '上传中...'
      let _this = this
      let fd = new FormData()
      fd.append('file', file.file)
      uploadImg(fd).then(res => {
        if (res.code === '0000') {
          file.status = 'done'
          this.fileListUrl = res.data.ossUrl || ''
          this.$notify({
            type: 'success',
            message: '图片上传成功'
          })
        } else {
          file.status = 'done'
          this.$notify(res.msg || '上传失败')
        }
      })
    },
    /**
     * @description
     */
    clock() {
      if (this.fileList.length <= 0) {
        this.$notify({
          type: 'warning',
          message: '请选择图片'
        })
        return
      }
      if (this.remark === '') {
        this.$notify({
          type: 'warning',
          message: '请输入备注'
        })
        return
      }
      let par = {
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile,
        staffName: this.userInfo.staffName,
        address: this.address,
        remark: this.remark,
        pictUrl: this.fileListUrl
      }

      addRemark(par).then(res => {
        if (res.data.code === '0000') {
          this.$notify({
            type: 'success',
            message: res.data.msg
          })
          this.$emit('showRemark', false)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#addressMap {
  height: 100%;
  .contain {
    height: 250px;
  }
  .address_ul {
    padding: 20px 0;
    font-size: 16px;
    background-color: #fff;
    .field-clock-btn {
      margin: 15px auto;
      display: flex;
      height: 40px;
      width: 300px;
      border-radius: 5px;
      text-align: center;
      .van-button__content {
        margin: 0 auto;
      }
    }
    .addres_li {
      display: flex;
      padding: 0 20px 8px;
      margin-bottom: 10px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .van-uploader {
        .van-uploader__upload,
        .van-uploader__preview {
          margin: 0;
        }
      }
      .address-moment{
        width: 230px;
      }
      /deep/.van-cell {
        padding-left: 0 !important;
      }
      span {
        color: #333;
        margin-right: 10px;
      }
      .limit {
        padding-left: 27px;
        position: relative;
        margin-top: 10px;
      }
      .limit::after {
        content: '*';
        position: absolute;
        color: #f00;
        left: 18px;
        top: 4px;
      }
      color: rgba(0, 0, 0, 0.7);
    }
  }
}
</style>
